import React, { useState } from "react"
import PropTypes from "prop-types"
import Modal from "@/components/core/Modal/Modal"
import htmlParser from "html-react-parser"
import {
  addAnalyticsForViewNowClick,
  addAnalyticsForCloseClick,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/analytics"
import Button3D from "@/styles/images/3D-Button.svg"
import useWindowResize from "@/hooks/useWindowResize"

const Product3Dmodel = ({
  pdpJson = {},
  sku = "",
  nvznList = [],
  vntanaList = [],
  productInfo = {},
  isImageReel3dModal = false,
  staticTexts = {},
}) => {
  const [width] = useWindowResize()
  const [showModal, setShowModal] = useState(false)
  const [scrollPosition, setScrollPosition] = useState(0)
  const openModal = () => {
    setShowModal(true)
    addAnalyticsForViewNowClick(productInfo)
    // set scroll position
    setScrollPosition(window.scrollY)
  }

  const closeModal = () => {
    setShowModal(false)
    addAnalyticsForCloseClick(productInfo)
    // restore the scroll position after closing the modal
    if (scrollPosition) {
      window.scrollTo({
        top: Number.parseInt(scrollPosition, 10),
        behavior: "instant",
      })
    }
    setScrollPosition(0)
  }
  const {
    iframeTitle = "",
    iframeDescription = "",
    iframeCTA = "",
    fileReferenceIframe = "",
    iframePlayers = [],
  } = pdpJson
  const areBothPlayersAvaialbe = nvznList.length && vntanaList.length
  const availablePlayerIdParam = nvznList.length ? "NVZN" : "VNTANA"
  const filterWith = areBothPlayersAvaialbe ? "priorityIframe" : "iframeID"

  const iframeToConsider =
    iframePlayers.find(item =>
      areBothPlayersAvaialbe
        ? item[filterWith]
        : item[filterWith].includes(availablePlayerIdParam)
    ) ?? {}
  const { iframeURL = "", iframeID = "" } = iframeToConsider
  const playerIds = (iframeID === "NVZN" ? nvznList : vntanaList) ?? []

  const getPlayerId = () => {
    const playerIdBasedSku = playerIds.filter(
      item => item.split("|")[0] === sku
    )
    return playerIdBasedSku.length ? playerIdBasedSku[0].split("|")[1] : ""
  }
  const playerId = getPlayerId()

  const pdp3DIframe = iframeURL.replace("{{ID}}", playerId)
  if (!playerId) return null
  return (
    <>
      {isImageReel3dModal ? (
        <>
          <button
            type="button"
            className="gallery-image-3d-button"
            onClick={() => openModal()}
          >
            <span className="button-3d">
              <img src={Button3D?.src} alt="" aria-hidden="true" />
            </span>
            <span className="button-3d-label">
              {width < 1023
                ? staticTexts.viewIn3DMobile
                : staticTexts.viewIn3DDesktop}
            </span>
          </button>
          {showModal && (
            <div className="product-detail-page__3d-modal">
              <div className="product-detail-page__3d-modal--modal-popup">
                <Modal
                  showModal={showModal}
                  onModalClose={closeModal}
                  isWhiteCloseIcon={true}
                  modalTitle={
                    width < 1023
                      ? staticTexts.viewIn3DMobile
                      : staticTexts.viewIn3DDesktop
                  }
                >
                  {pdp3DIframe ? htmlParser(pdp3DIframe) : null}
                </Modal>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="product-detail-page__3d-modal">
          <div className="product-detail-page__3d-modal--title">
            {iframeTitle}
          </div>
          <div className="product-detail-page__3d-modal--decs">
            {iframeDescription}
          </div>
          <div className="product-detail-page__3d-modal--modal-popup">
            <div className="product-detail-page__3d-modal--icon">
              {fileReferenceIframe ? (
                <img src={fileReferenceIframe} alt={iframeCTA} />
              ) : null}
              <div className="product-detail-page__3d-modal--button">
                <span
                  tabIndex={0}
                  role="button"
                  aria-label="view"
                  onClick={openModal}
                >
                  {iframeCTA}
                </span>
              </div>
            </div>
            <Modal
              showModal={showModal}
              onModalClose={closeModal}
              isWhiteCloseIcon={true}
            >
              {pdp3DIframe ? htmlParser(pdp3DIframe) : null}
            </Modal>
          </div>
        </div>
      )}
    </>
  )
}

Product3Dmodel.propTypes = {
  pdpJson: PropTypes.shape({
    iframeTitle: PropTypes.string,
    iframeDescription: PropTypes.string,
    iframeCTA: PropTypes.string,
    fileReferenceIframe: PropTypes.string,
    iframePlayers: PropTypes.arrayOf(PropTypes.object),
  }),
  sku: PropTypes.string,
  nvznList: PropTypes.arrayOf(PropTypes.string),
  vntanaList: PropTypes.arrayOf(PropTypes.string),
  productInfo: PropTypes.object,
  isImageReel3dModal: PropTypes.bool,
  staticTexts: PropTypes.shape({
    viewIn3DMobile: PropTypes.string,
    viewIn3DDesktop: PropTypes.string,
  }),
}

export default Product3Dmodel
